import { restApi } from '../../api/restApiSlice';

export type EventType = 'coupon' | 'referral';

export type EventDetails = {
  message: string;
} & Record<string, any>;

export type EnvironmentDto = {
  environmentName: string;
  apiToken: string;
  cacheFreshness: number;
  automaticRecachingPaused: boolean;
  ignoreAllQueryParams: boolean;
  mobileOptimizedRendering: boolean;
  onlyServeCacheHits: boolean;
  queryParamsWhitelist: boolean;
  customRecacheDelay: number;
  extractHiddenCss: boolean;
  enforceHttpsProtocol: boolean;
  desktopViewport: string;
  mobileViewport: string;
  imageLoading: boolean;
  renderLocation: string;
  skipCustomElementsForcePolyfill: boolean;
  removeStyleTags: boolean;
  removeUrlHash: boolean;
  enableServiceWorker: boolean;
  renderingTimeout: number;
  parseShadowDom: boolean;
  fixHeadTag: boolean;
  retryTimedOutRenders: boolean;
  retryDirtyRenders: boolean;
  desktopUserAgent: string;
  mobileUserAgent: string;
  prerenderCssLocation: string;
  preCheckStatus: boolean;
  scrollEnabled: boolean;
  minimumBodyLength: number;
  scrollToBottomAfterPageLoad: boolean;
};

export type UserEventLogDto = {
  modifiedBy: string;
  modifiedAt: string; // Date as ISO string
  values: EnvironmentDto | EventDetails;
};

export type GetUserEventLogResponseDto = {
  data: UserEventLogDto[];
};

export const auditLogApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLog: builder.query<UserEventLogDto[], ''>({
      query: () => ({ url: '/v3/user-event-log', method: 'GET' }),
      providesTags: ['AuditLog'],
      transformResponse: (response: GetUserEventLogResponseDto) => response.data,
      transformErrorResponse: (response) => response.data,
    }),
  }),
});

export const { useGetAuditLogQuery } = auditLogApi;
